module.exports = __webpack_public_path__ + "img/3.df7de1c1.png";